module.exports = __webpack_public_path__ + "img/contact-info-row-chevy.bef49072.png";